import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const showAdvertisersModalSelector = createSelector(modalsSelector, (modals) => modals.showAdvertisers);

export default showAdvertisersModalSelector;
